import React from 'react'

function RestHospThree() {
   return (
      <section className="container-fluid section_primary_bg industries-bg-image">
         <div className="container-4xxl text-center mb-5 innovation_comman blockchain_innovation">
            <h2 className="tech_title section_heading_title mb-3">
               Essential Features for Successful Restaurant & Hospitality
               Software
            </h2>

            <p className="sub_body">
               We are a top-tier restaurant and hospitality app development company committed to transforming guest experiences with customized, tech-driven solutions. Our apps streamline online reservations, enhance customer engagement, and optimize service management, empowering your business to thrive in the competitive hospitality industry.
            </p>
         </div>

         <div className="container text-center">
            <div className="innovation_card_main industries-card blockchain_innovation_card_main">
               <div className="row g-4 industry-grid travel-tourism-wrap">
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">01</p>
                        <h4 className="industry-subtitle">Advanced Analytics Dashboard</h4>
                        <p className="industry-description">
                           Our restaurant and hospitality applications have an integrated
                           dashboard that provides real-time intelligence on customer action,
                           service operation, and sales trends. Using in-depth analysis, you
                           are able to monitor order trends, guest habits, and booking details.
                           This enables you to make informed business decisions, optimize
                           marketing efforts, and drive profitability.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">02</p>
                        <h4 className="industry-subtitle">Interactive Menu Display</h4>
                        <p className="industry-description">
                           We integrate highly visual and interactive menus for restaurants and
                           service catalogs for hospitality apps. These displays include
                           appetizing images, detailed descriptions, and custom filters,
                           enhancing the browsing experience. This feature encourages impulse
                           ordering and simplifies the selection process for both dining and
                           hotel services.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">03</p>
                        <h4 className="industry-subtitle">Geo-Targeted Promotions</h4>
                        <p className="industry-description">
                           Our apps take advantage of high-end GPS tracking to provide
                           location-based offers for restaurants and hospitality businesses.
                           You can use this option to send offers to close diners with special
                           deals or give special packages to hotel patrons. Geo-targeted offers
                           help increase foot traffic and boost bookings, maximizing revenue
                           potential.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">04</p>

                        <h4 className="industry-subtitle">Instant Table & Room Reservations</h4>
                        <p className="industry-description">
                           We provide an instant booking system which lets users book restaurant
                           tables or hotel rooms instantly. This reduces waiting times,
                           maximized space utilization, and improves the customer experience.
                           With auto-confirmations, you can facilitate a smoother booking process
                           and general efficiency.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">05</p>

                        <h4 className="industry-subtitle">Event Scheduling & Promotion</h4>
                        <p className="industry-description">
                           Our applications include an events calendar of upcoming restaurant
                           events (theme evenings, live performances) and hospitality services
                           (spa procedures, special offers). The function keeps customers up to
                           date, invites engagement, and enhances app usage, allowing you to
                           market your special events and offers successfully.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">06</p>

                        <h4 className="industry-subtitle">Seamless Payment & Checkout</h4>
                        <p className="industry-description">
                           We implement frictionless payment solutions with multiple secure
                           checkout options. Consumers will receive real-time order status
                           updates, booking confirmations, and invoice notifications in addition
                           to paying using credit cards, e-wallets, or digital transfers. This
                           one-step payment process simplifies convenience for restaurant and
                           hospitality users.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">07</p>

                        <h4 className="industry-subtitle">Branch & Service Locator</h4>
                        <p className="industry-description">
                           We incorporate geo-location services that enable users to find nearby
                           restaurant outlets, partner hotels, or hospitality services. The
                           feature shows correct directions and availability of services,
                           allowing customers to easily locate your outlets, and increasing
                           visibility and customer traffic.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">08</p>

                        <h4 className="industry-subtitle">One-Tap Reordering & Takeout</h4>
                        <p className="industry-description">
                           Customers can reorder their favorite food easily. For hospitality
                           services, visitors can easily re-order services like housekeeping or
                           in-room dining with a click. Both convenience and client pleasure are
                           enhanced by this.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">09</p>

                        <h4 className="industry-subtitle">User Profile Management</h4>
                        <p className="industry-description">
                           We provide complete profile management that allows customers to store
                           preferences, delivery addresses, and payment options. For hotel apps,
                           guests can store room preferences and booking information. This
                           functionality makes the experience more personalized, accelerates
                           future checkouts, and improves customer retention.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">10</p>

                        <h4 className="industry-subtitle">Loyalty & Referral Program Integration</h4>
                        <p className="industry-description">
                           Our restaurant and hospitality apps have referral and loyalty
                           programs that reward customers with points, discounts, or special
                           offers. This drives repeat business and motivates app use through
                           referral incentives, increasing customer engagement and app downloads.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">11</p>

                        <h4 className="industry-subtitle">Multi-Payment Gateway Options</h4>
                        <p className="industry-description">
                           We support several payment gateways such as credit cards, e-wallets,
                           bank transfers, and digital coupons. This supports safe and convenient
                           payments for dine-in orders as well as hotel services, with the
                           advantage for users and also a good user experience of the app overall.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <p className="industry-number-title">12</p>

                        <h4 className="industry-subtitle">Deals & Discount Coupons</h4>
                        <p className="industry-description">
                           Our apps include smart auto discount offers, such as promo codes,
                           holiday specials, and membership discounts. This keeps customers
                           engaged and ready for repeat ordering and bookings, making you gain
                           more customer loyalty and sales.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <p className="industry-number-title">13</p>

                        <h4 className="industry-subtitle">Smart Push Notifications</h4>
                        <p className="industry-description">
                           We apply strategic push notifications that enable you to send live
                           updates, special promotions, and reminders. The notifications
                           increase customer engagement, drive new offers, and drive repeat
                           business by putting your brand top of mind.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <p className="industry-number-title">14</p>

                        <h4 className="industry-subtitle">Rich Media Integration</h4>
                        <p className="industry-description">
                           Our apps support high-resolution images, videos, and virtual tours
                           to showcase restaurant ambiance, hotel amenities, and menu items.
                           This makes your app visually engaging and increases customer trust
                           and interest, driving more engagement and conversions.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <p className="industry-number-title">15</p>

                        <h4 className="industry-subtitle">Customer Feedback & Ratings</h4>
                        <p className="industry-description">
                           Our in-app review system enables customers to rate their experience
                           and provide feedback directly. Good reviews enhance credibility, while
                           good feedback assists you in enhancing your services. Social media
                           platform integration enhances the visibility and reputation of your
                           brand.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default RestHospThree
